import { IRequestFetcherOptions, IParamsOption } from "src/common/razzle-platform-components/types"
import { fetchReviewsOfPurchaseItem, fetchReviewsOfPurchaseItems } from "src/common/razzle-platform-reviewofpurchaseitem/effects"


// we fixed this PRODUCT_PROPS_ID for use it to save our props in reudcer
export const REVIEW_OF_PURCHASE_ITEM_PROPS_ID = 'reviewsProps'


// we use this function to get the product on the server side
export async function getInitialPropsOfReviewsOfPurchaseItem({ route }, { dispatch }, id: string, options: IParamsOption={params: null, useUrlParams: true, usePagination: true }) {
    try {

        const queryOptions: IRequestFetcherOptions = {
            // prams given from url
            searchParams: route.query,
            // forced params by user not it's shown in url
            params: options.params,
            // to allow use pagination
            usePagination: options.usePagination,
            // to allow use search parms from url
            useUrlParams: options.useUrlParams
        }

		// get the product by execute the effect fetchProduct and pass it queryOptions
		const { reviews, pagination } = await fetchReviewsOfPurchaseItem(id, queryOptions)

        // save the initialProps in the reducer
		dispatch.ssrModel.setInitialProps({ [REVIEW_OF_PURCHASE_ITEM_PROPS_ID]: { reviews, pagination, queryOptions } })

    } catch (error) {
        console.log('mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm', error)
    }
}

// we fixed this PRODUCTS_PROPS_ID for use it to save our props in reudcer
export const REVIEW_OF_PURCHASE_ITEMS_PROPS_ID = 'reviewsProps'

// we use this function to get the products on the server side
export async function getInitialPropsOfReviewsOfPurchaseItems({ route }, { dispatch }, options: IParamsOption={params: null, useUrlParams: true, usePagination: true }) {
	try {
        const queryOptions: IRequestFetcherOptions = {
            // prams given from url
            searchParams: route.query,
            // forced params by user not it's shown in url
            params: options.params,
            // to allow use pagination
            usePagination: options.usePagination,
            // to allow use search parms from url
            useUrlParams: options.useUrlParams
        }

        // get the products by execute the effect fetchProducts and pass it queryOptions
        const { reviews, pagination } = await fetchReviewsOfPurchaseItems(queryOptions)

        // save the initialProps in the reducer
        dispatch.ssrModel.setInitialProps({ [REVIEW_OF_PURCHASE_ITEMS_PROPS_ID]: { reviews, pagination, queryOptions } })

	} catch (error) {
        console.log('errrrorrrr', error)
	}
}
